<script>
import TableWithPagination from '../table-with-pagination';
import {addQueryParams} from '../../libs/url';
import ActionsColumn from './actions-column';
import eventBus from '../../event-bus';

export default {
  extends: TableWithPagination,

  components: {
    ActionsColumn,
  },

  data() {
    return {
      search: null,
      filters: {},
      isBusy: false,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search(current, previous) {
      this.filters = current
          ? _.assign({}, this.filters, {search: current})
          : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @emits show-tag-form-dialog
     */
    onCreate() {
      eventBus.$emit('show-tag-form-dialog', this.createUrl);
    },

    /**
     * @param {string} url
     * @emits show-tag-form-dialog
     */
    onEdit({url}) {
      eventBus.$emit('show-tag-form-dialog', url);
    },

    /**
     * @param {string} url
     */
    onDelete({url}) {
      this.isBusy = true;
      axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(() => this.isBusy = false);
    },

    /**
     * @param {string} url
     */
    onRestore({url}) {
      this.isBusy = true;
      axios.post(url, {_method: 'POST'})
        .then(({data: {message}}) => {
          _.isString(message) && this.$message.success(message);
          this.refresh();
        })
        .catch((err) => {
          const message = _.get(err, 'response.data.message');
          _.isString(message) && this.$message.error(message);
        })
        .then(() => this.isBusy = false);
    },
  }
}
</script>
